exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".agreement_page{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0 14px;overflow:auto;height:100vh;font-family:\"Microsoft YaHei\";color:#000}.agreement_page h3,.agreement_page h4{font-weight:600;margin:20px 0;color:#000}.agreement_page h3{font-size:18px}.agreement_page h4{font-size:16px}.agreement_page p{text-indent:2em;margin:10px 0;font-size:15px;line-height:26px}.agreement_page .footer{font-size:13px;color:gray;text-align:center;line-height:60px}.text-align-center{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/view/home/agreement.scss
// module id = 981
// module chunks = 0